import { useMemo } from 'react';
import classNames from 'classnames';
import CTNSpinner from '@ctn/ui/components/ctn-spinner';

type LoadingProps = {
	readonly className?: string;
	readonly isFull?: boolean;
	readonly title?: string;
};

const classNameComponente = 'c-cnm-loading';

export const Loading = ({ className, isFull = false, title = '' }: LoadingProps) => {
	const loadingClassName = useMemo(
		() =>
			classNames(className, classNameComponente, {
				[`${classNameComponente}--full`]: isFull,
			}),
		[className, isFull],
	);

	return (
		<div className={loadingClassName}>
			<div className={`${classNameComponente}__spinner`}>
				<CTNSpinner size="size-48" />
				{title}
			</div>
		</div>
	);
};
